import { Component, Input } from '@angular/core';

@Component({
  selector: 'ti-promotion-bar',
  template: `<div id="merge-status-block" class="print-hidden" *ngIf="mergeData">
              <span *ngFor="let branch of getBranches()"
                    [ngClass]="getLabelClass(branch.commits)"
                    data-placement="bottom"
                    [attr.title]="branch.commits[0] + '/' + branch.commits[1]"
                    class="label" style="margin: .25em; cursor: pointer;">
                {{ branch.name }}
              </span>
            </div>`
})
export class TiPromotionBarComponent {
  @Input() mergeData: any;

  getBranches() {
    return Object.keys(this.mergeData || {}).map(branchName => ({
      name: branchName,
      commits: this.mergeData[branchName]
    }));
  }

  getLabelClass(commits: number[]): string {
    if (commits[1] === 0) {
      return 'label-default';
    }
    if (commits[0] > 0 && commits[1] > 0 && commits[0] < commits[1]) {
      return 'label-warning';
    }
    if (commits[0] === 0 && commits[1] > 0) {
      return 'label-danger';
    }
    if (commits[0] === commits[1] && commits[1] > 0) {
      return 'label-success';
    }
    return '';
  }
}
